module.exports = __webpack_public_path__ + "static/media/material-light.006f67cb.jpg";